import { rem } from 'polished';

import { Box, AppBar, styled, Toolbar } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';

const StyledHeader = styled(AppBar)(() => ({
  backgroundColor: `#fff`,
  display: `flex`,
  justifyContent: `space-between`,
  boxShadow: `0 0 0 0 transparent`,
  minHeight: `${rem(64)}`,

  borderBottom: `1px solid #fafafa`,
  position: `relative`,
}));

const StyledSvgLogoDestination = styled(Box)(({ theme }) => ({
  display: `flex`,
  justifyContent: `flex-start`,
  alignItems: `center`,
  height: `${rem(64)}`,
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    justifyContent: 'center',
    'flex-basis': `50%`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

const StyledIconButtonContainer = styled(Box)(({ theme }) => ({
  'flex-basis': `25%`,
  justifyContent: 'flex-start',
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

const StyledMenuIcon = styled(MenuIcon)(() => ({
  color: `#000`,
}));

const StyledActions = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    'flex-basis': `25%`,
  },
}));

export {
  StyledHeader,
  StyledSvgLogoDestination,
  StyledMenuIcon,
  StyledIconButtonContainer,
  StyledToolbar,
  StyledActions,
};
